export default __webpack_public_path__ + "static/media/337.38facfb1.gif";